(ns admin.events.containers.curriculum-selection
  "Responsible for bootstrapping the curriculum-selection page."
  (:require [kyber.router :refer [ensure-resource-v2]]
            [kyber.events.eql :as eql]
            [kyber.events.utils :refer [kyber-event-fx]]
            [re-frame.core :as re-frame]
            [kyber.lib.kyber-db :as kyber-db]))

(def curriculum-keys [:curriculum/uuid
                      :curriculum/can-add-activity
                      :curriculum/clp-banner
                      :curriculum/created-at
                      :curriculum/description
                      :curriculum/max-number-of-activities
                      :curriculum/name
                      :curriculum/total-number-of-activities])

(def curriculum-keys-v2 [:content-provider.curricula/page-info
                         :content-provider.curricula/edges])

(when ^boolean js/goog.DEBUG
  (def event-doc-fetch-curricula-failure
    {:description "Get curriculum index page (Failure)"
     :changelog
     [{:date "21JAN21"
       :event-version 0
       :data {}}]}))

(defn fetch-curricula-failure
  [{:keys [db]} [event-name _err]]
  {:db db
   :dispatch-n [[:analytics/save-datapoint {:event event-name
                                            :event-version 0}]]})

(kyber-event-fx ::fetch-curricula-failure fetch-curricula-failure)


(when ^boolean js/goog.DEBUG
  (def event-doc-fetch-curricula-success
    {:description "Get curriculum index page (Success)"
     :changelog
     [{:date "21JAN21"
       :event-version 0
       :data {}}]}))

(defn fetch-curricula-success
  [{:keys [db]} [event-name initial-load res]]
  (let [{content-provider-uuid :content-provider/uuid :as content-provider}
        (get res :app.current-session/content-provider)

        {:content-provider.curricula/keys [edges page-info]}
        (get content-provider :content-provider/curricula)]
    {:db (cond-> db
           (true? initial-load)
           (kyber-db/retract-record {:model :content-provider}
                                    {:content-provider/uuid content-provider-uuid})

           :always
           (kyber-db/tx-record {:model :content-provider}
                               (assoc content-provider
                                      :content-provider/curricula edges
                                      :content-provider.pagination/page-info page-info)))
     :dispatch-n [[:analytics/save-datapoint {:event event-name
                                              :event-version 0}]]}))

(kyber-event-fx ::fetch-curricula-success fetch-curricula-success)


(when ^boolean js/goog.DEBUG
  (def event-doc-fetch-curricula
    {:description "Get curriculum index page"
     :changelog
     [{:date "21JAN21"
       :event-version 0
       :data {}}]}))

(defn fetch-curricula
  [{:keys [db]} [event-name {:keys [offset limit initial-load sort-key sort-order]
                             :or {offset 0 limit 25 initial-load true sort-key :last-updated sort-order :dsc}}]]
  {:db db
   :dispatch-n [[:analytics/save-datapoint {:event event-name
                                            :event-version 0}]]
   :request
   (eql/request
    db
    {:name event-name
     :params [{:app.current-session/content-provider
               [:content-provider/uuid
                {`(:content-provider/curricula
                   {:sort-order ~sort-order
                    :sort-key ~sort-key
                    :limit ~limit
                    :offset ~offset})
                 [:content-provider.curricula/page-info
                  {:content-provider.curricula/edges
                   curriculum-keys}]}]}]
     :on-success [::fetch-curricula-success initial-load]
     :on-failure [::fetch-curricula-failure]})})

(kyber-event-fx :curriculum-selection/fetch-curricula fetch-curricula)

;; Created a separate event name so that the list of curricula is only removed from UI
;; while a sort request is dispatching
(kyber-event-fx :curriculum-selection/sort-curricula fetch-curricula)

(def ensure-curriculum-selection
  ""
  (partial ensure-resource-v2 :curriculum-selection/fetch-curricula
           #(re-frame/dispatch [:curriculum-selection/fetch-curricula %])))
